module.exports = __webpack_public_path__ + "img/GM.cdc1427a.svg";